import { render, staticRenderFns } from "./AtemTeeSlider.vue?vue&type=template&id=4cf7850a&"
import script from "./AtemTeeSlider.vue?vue&type=script&lang=js&"
export * from "./AtemTeeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports